import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import { useNavigate, Link } from 'react-router-dom';
import { parseErr } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { Logo } from '@/components/brand/Logo';

export default function RegisterPage() {
  const { register, meta } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email.trim().toLowerCase(), password, name.trim());
      toast.success('Welcome to 32December OS');
      nav('/');
    } catch (e) {
      const msg = parseErr(e);
      if (msg === 'wrong_domain') { nav('/wrong-domain'); return; }
      toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 border rounded-xl p-6 bg-[hsl(var(--card))]" style={{ borderColor: 'hsl(var(--border))' }} data-testid="register-form">
        <div className="flex flex-col items-center gap-2">
          <Logo variant="stacked" surface="light" height={80} testId="register-brand-logo" />
          <div className="text-[12px] text-[hsl(var(--foreground-subtle))]">Create your account</div>
        </div>
        <label className="block">
          <span className="text-[12px] font-medium text-[hsl(var(--foreground-muted))]">Full name</span>
          <Input data-testid="register-name" required value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Priya Sharma" className="mt-1" />
        </label>
        <label className="block">
          <span className="text-[12px] font-medium text-[hsl(var(--foreground-muted))]">Work email</span>
          <Input data-testid="register-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={`you@${meta?.allowed_email_domain}`} className="mt-1" />
        </label>
        <label className="block">
          <span className="text-[12px] font-medium text-[hsl(var(--foreground-muted))]">Password</span>
          <Input data-testid="register-password" required type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="minimum 6 characters" className="mt-1" />
        </label>
        <Button data-testid="register-submit" disabled={busy} type="submit" className="w-full">Create account</Button>
        <div className="text-[12.5px] text-center text-[hsl(var(--foreground-muted))]">
          Already registered? <Link className="underline" to="/login">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
